import {toggleModal} from "./toggleModalActions";

const apiErrorMessage = async response => {
    const fallback = `Error: ${response.status} ${response.statusText}`;
    try {
        const text = await response.text();
        if (!text) return fallback;
        try {
            const json = JSON.parse(text);
            return json.message || json.error || text;
        } catch (e) {
            return text;
        }
    } catch (e) {
        return fallback;
    }
};

export const getDrainStationsPending = () => {
    return {
        type: 'GET_DRAIN_STATIONS_PENDING'
    }
};

export const getDrainStationsSuccess = (stations, page, pageCount, itemsCount) => {
    return {
        type: 'GET_DRAIN_STATIONS_SUCCESS',
        stations,
        page,
        pageCount,
        itemsCount
    }
};

export const getDrainStationsError = error => {
    return {
        type: 'GET_DRAIN_STATIONS_ERROR',
        error: error
    }
};

export const addDrainStationSuccess = () => {
    return {
        type: 'ADD_DRAIN_STATION_SUCCESS'
    }
};

export const selectDrainStation = (station, page) => {
    return {
        type: 'SELECT_DRAIN_STATION',
        selected: { station: station, page }
    };
};

export const setDrainStationsFilters = filters => {
    return {
        type: 'SET_DRAIN_STATIONS_FILTERS',
        filters: filters
    }
};

export const getDrainStations = (page, numberPerPage, search) => {
    const pageNumber = page ? page : 1;
    // const filterValue = filter ? filter : 'ALL';
    const searchParam = search ? `&search_query=${search}` : '';
    const numberOfRecords = numberPerPage ? numberPerPage : 3;

    return dispatch => {
        dispatch(getDrainStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/drain_water_station_list?page=${pageNumber}&number_on_page=${numberOfRecords}${searchParam}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getDrainStationsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getDrainStationsSuccess(res.drainWaterStations, res.page, res.pageCount, res.itemsCount))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addDrainStation = data => {
    return dispatch => {
        dispatch(getDrainStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/create_drain_water_station`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addDrainStationSuccess());
                    dispatch(getDrainStations(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getDrainStationsError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const editDrainStation = (data) => {
    return dispatch => {
        dispatch(getDrainStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_drain_water_station`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getDrainStations(1))
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(getDrainStationsError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const deleteDrainStation = (id) => {
    return dispatch => {
        dispatch(getDrainStationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/drain_water_station_delete/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getDrainStations());
                } else {
                    dispatch(getDrainStationsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getDrainWaterStationHistory = (stationId, dateFrom, dateTo, signal) => {
    const body = {stationId};
    if (dateFrom && dateTo) {
        body.dateFrom = dateFrom;
        body.dateTo = dateTo;
    }

    return fetch(`${process.env.REACT_APP_API_URL}/reports/drain-water-stations`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        },
        body: JSON.stringify(body),
        signal
    }).then(async response => {
        if (!response.ok) {
            throw new Error(await apiErrorMessage(response));
        }
        return response.json();
    });
};

export const startDrainStationAiValidation = (data, signal) => {
    return fetch(`${process.env.REACT_APP_API_URL}/drain_water_station_ai_validation/start`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        },
        body: JSON.stringify(data),
        signal
    }).then(async response => {
        if (!response.ok) {
            throw new Error(await apiErrorMessage(response));
        }
        return response.json();
    });
};

export const getDrainStationAiValidationSession = (sessionId, signal) => {
    return fetch(`${process.env.REACT_APP_API_URL}/drain_water_station_ai_validation/${sessionId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        },
        signal
    }).then(async response => {
        if (!response.ok) {
            throw new Error(await apiErrorMessage(response));
        }
        return response.json();
    });
};
